import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import Contact from "./pages/Contact";
import About from "./pages/About";
import ICBCRenewal from "./pages/ICBCRenewal";
import Claims from "./pages/Claims";
import Forms from "./pages/Forms";
import SubServicePage from "./pages/SubServicePage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/car-insurance" element={<ServicePage slug="car-insurance" />} />
          <Route path="/home-insurance" element={<ServicePage slug="home-insurance" />} />
          <Route path="/business-insurance" element={<ServicePage slug="business-insurance" />} />
          <Route path="/travel-insurance" element={<ServicePage slug="travel-insurance" />} />
          <Route path="/super-visa-insurance" element={<ServicePage slug="super-visa-insurance" />} />
          <Route path="/icbc-policy-renewal" element={<ICBCRenewal />} />
          <Route path="/claims" element={<Claims />} />
          <Route path="/forms" element={<Forms />} />
          <Route path="/coverage/:slug" element={<SubServicePage />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
